export default __webpack_public_path__ + "static/media/intermediate.923c06bb.png";